import 'bootstrap';          // JS Bootstrap
import './styles.scss';      // <--- ОБЯЗАТЕЛЬНО! Импортируем свои SASS

// Твой кастомный JS ниже
import './plotlycharts.js';
import './plotlygraphics.js';
import './theme.js';
import './leftsidebarmenu.js';
import './sidebarDrilldown.js';
import './dashboardContentLoader.js';
import './contentWidth.js';
console.log("Webpack+Bootstrap5.3 loaded!");
